<template>
  <div class="layouts-main">
    <div class="nav" v-if="navbar">
      <navbar/>
      <div :style="{height: nonChrome?'120px':'80px'}"></div>
    </div>
    <div class="main">
      <div class="sidebar">
        <slot name="sidebar"></slot>
        <slot name="sidebarContent"></slot>
      </div>
      <div class="content">
        <slot name="content"></slot>
        <page
          v-if="total > 0"
          :current-page="currentPage"
          :total="total"
          :page-size="pageSize"
          @prev-click="$emit('prev-click')"
          @next-click="$emit('next-click')"
          @current-change="currentChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import page from '@/components/base/page';
import navbar from '@/components/base/navbar';
import {mapState} from "vuex";
export default {
  name: 'myLayout',
  components: {
    navbar,
    page
  },
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    navbar: {
      type: Boolean,
      default: true
    },
    pageSize: Number
  },
  data() {
    return {};
  },
  computed:{
    ...mapState('global', ['nonChrome'])
  },
  methods: {
    currentChange(page) {
      this.$emit('current-change', page)
    }
  }
}
</script>
<style lang="scss" scoped>
  .layouts-main {
    width: 100%;
    background: #1A1C20;
    .main {
      width: 1200px;
      margin: auto;
      // display: flex;
      .sidebar {
        width: 100%;
        // margin-right: 16px;
      }
      .content {
        width: 100%;
        // padding-bottom: 56px;
      }
    }
  }
</style>